/* Keep Shopify's native option-value and cart behavior; enhance presentation only. */
document.addEventListener('click', (event) => {
  const choice = event.target.closest('[data-shop-color]');
  if (choice) {
    const select = document.getElementById(choice.dataset.shopSelect);
    const option = select && Array.from(select.options).find((item) => item.dataset.optionValueId === choice.dataset.shopValue);
    if (option) {
      select.value = option.value;
      const panel = choice.closest('details');
      if (panel) panel.open = false;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (event.target.closest('[data-shop-options]')) {
    const picker = document.querySelector('.shop-product variant-selects');
    picker?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    picker?.querySelector('select, input')?.focus({ preventScroll: true });
  }
});
document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-shop-color-search]')) return;
  const panel = event.target.closest('.shop-color-picker');
  const query = event.target.value.trim().toLocaleLowerCase();
  let count = 0;
  panel.querySelectorAll('[data-shop-color]').forEach((choice) => {
    choice.hidden = !choice.dataset.shopColor.toLocaleLowerCase().includes(query);
    if (!choice.hidden) count += 1;
  });
  panel.querySelector('.shop-color-empty').hidden = count > 0;
});
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-shop-color-search]')) event.stopPropagation();
}, true);
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const count = event?.cartData?.item_count ?? event?.data?.cart?.item_count;
    const updateCount = (value) => document.querySelectorAll('[data-shop-cart-count]').forEach((node) => { node.textContent = value; });
    if (typeof count === 'number') updateCount(count);
    else fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => { if (typeof cart?.item_count === 'number') updateCount(cart.item_count); })
      .catch(() => {});
  });
}
